/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import CONFIG from "../../config";
import t from "../../trans";

class Footer extends React.Component {
    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="footer">
                <div>
                    <small>{t(CONFIG.copyright)}</small>
                </div>
            </div>
        );
    }
}

export default Footer;
